<template>
    <div>
        <div class="overlay" v-if="searchResult || searchResult" v-on:click="() => { searchResult=false; searchResult=false; }"></div>

        <div class="files_table_container" style="margin-bottom: 20px;">
            <div class="content_row">
                <select class="sub_group_select" v-model="search_type" @change="searchItems()">
                    <option :value="null" disabled>Тип пошуку</option>
                    <option :value="2">За артикулом</option>
                    <option :value="3">За назвою</option>
                </select>
                <div class="search_input_container" :class="{zindex0: !zindex }">
                    <div class="search_input_block">
                        <input class="catalog_search_input" @focus="() => {searchResult = true; }" v-on:keyup="searchItems()" v-model="searchval" placeholder="Пошук" />
                        
                        <svg v-if="!searchResult" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                        </svg>

                        <svg id="close_modal" v-if="searchResult" @click="clearSearch()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="search_results" v-if="searchResult">
                        <div class="products" v-if="searchProducts.length">
                            <p class="cat_title" v-for="(product, key) in searchProducts" :key="key" @click.stop="addProduct(product.remote_id)">{{ product.name }}</p>
                        </div>
                        <p class="cat_title" v-if="!searchProducts.length">Немає результатів</p>
                    </div>
                </div>
            </div>
        </div>

        <DataTable :value="itemsData" :reorderableColumns="true" @rowReorder="onRowReorder" paginator :rows="50" :rowsPerPageOptions="[50, 100, 200]" v-model:selection="selectedItems" tableStyle="min-width: 50rem" class="productTabTable">
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column rowReorder headerStyle="width: 3rem" :reorderableColumn="false">
                <template #rowreordericon>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.00004 13.6673L4.16671 10.834L5.11671 9.88398L6.33337 11.1007V7.66732H2.91671L4.13337 8.86732L3.16671 9.83398L0.333374 7.00065L3.15004 4.18398L4.10004 5.13398L2.90004 6.33398H6.33337V2.90065L5.11671 4.11732L4.16671 3.16732L7.00004 0.333984L9.83337 3.16732L8.88337 4.11732L7.66671 2.90065V6.33398H11.0834L9.86671 5.13398L10.8334 4.16732L13.6667 7.00065L10.8334 9.83398L9.88337 8.88398L11.1 7.66732H7.66671V11.084L8.86671 9.86732L9.83337 10.834L7.00004 13.6673Z" fill="#356EEF"/>
                    </svg>
                </template>
            </Column>
            <Column field="article" header="Артикул">
                <template #body="slotProps">
                    {{
                        slotProps.data.article
                    }}
                </template>
            </Column>
            <Column field="id" header="ID">
                <template #body="slotProps">
                    {{
                        slotProps.data.id
                    }}
                </template>
            </Column>
            <Column field="name" header="Найменування">
                <template #body="slotProps">
                    {{
                        slotProps.data.name
                    }}
                </template>
            </Column>
            <Column v-if="type === 'accessories'" field="type_id" header="Тип аксесуару">
                <template #body="slotProps">
                    <Dropdown v-model="slotProps.data.type_id" @change="changeType" filter :options="types" optionLabel="name" optionValue="code" placeholder="Інше" style="width: 100%;" />
                </template>
            </Column>
            <Column v-if="type === 'buy_with_products'" field="is_mirror" header="Дзеркальний зв’язок">
                <template #body="slotProps">
                    <input @change="changeType" type="checkbox" v-model="slotProps.data.is_mirror">
                </template>
            </Column>
            <Column field="brand" header="Бренд">
                <template #body="slotProps">
                    {{
                        slotProps.data.brand
                    }}
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <a href="#" @click.prevent="() => {selectedItems=[]; selectedItems.push(slotProps.data); deleteItems()}">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                        </svg>
                    </a>
                </template>
            </Column>
        </DataTable>
        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="saveProduct()">Зберегти</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedItems.length" @click="deleteItems()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>

        <Toast />
    </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Dropdown from 'primevue/dropdown';
import Column from 'primevue/column';
import Toast from 'primevue/toast';
import swal from 'sweetalert2';
import axios from "axios";

export default {
    props: {
        items: {
            type: Array,
            default: null
        },
        types: {
            type: Array,
            default: []
        },
        selectedProductId: {
            type: Number,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        routeType: {
            type: String,
            default: null
        },
        zindex: {
            type: Boolean,
            default: false
        },
    },
    components: {
        DataTable,
        Dropdown,
        Column,
        Toast,
        swal,
    },

    data() {
        return {
            search_type: 2,
            searchResult: false,
            showClearInput: false,
            searchval: null,

            searchProducts: [],
            selectedItems: [],
            itemsData: _.cloneDeep(this.items),
        }
    },

    methods: {
        searchItems() {
            if (this.searchval) {
                this.showClearInput = true;
            } else {
                this.showClearInput = false;
            }
            if (this.searchval && this.searchval.length > 2) {
                axios.post(this.route('api.vector.catalog-tree-search'), {value: this.searchval, search_type: this.search_type})
                    .then((result) => {
                        this.searchProducts = result.data.products;

                        this.searchResult = true;
                    }).catch((error) => {
                        console.log(error);
                        this.searchResult = true;
                        window.scroll(0, 0);
                    })
            }
        },

        onRowReorder(event) {
            this.itemsData = event.value;

            this.$emit(this.type, this.itemsData)
        },

        addProduct(id) {
            axios.post(this.route('api.catalog.product.'+ this.routeType +'.add'), {data: id, id: this.selectedProductId})
                .then((result) => {
                    this.itemsData = result.data[this.type]

                    this.clearSearch()
                    this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Дані по товару успішно оновлено', life: 3000 });
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                }).finally(() => {
                    this.$emit(this.type, this.itemsData)
                })
        },

        deleteItems() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані аксесуари будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedItems = []
                    return
                }

                axios.post(this.route('api.catalog.product.'+ this.type +'.delete'), {data: this.selectedItems, id: this.selectedProductId})
                    .then((result) => {
                        this.itemsData = result.data[this.type]
                        this.selectedItems = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Аксесуари успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedItems = []
                        console.log(error);
                        window.scroll(0, 0);
                    }).finally(() => {
                        this.$emit(this.type, this.itemsData)
                    })

            });
        },

        saveProduct() {
            this.$emit('saveProduct')
        },

        changeType() {
            this.$emit(this.type, this.itemsData)
        },

        clearSearch() {
            this.searchval = null;
            this.showClearInput = false;
            this.searchResult = false;
        },
    }
}
</script>

<style scoped>
.files_table_container {
    margin-top: 20px;
}
.files_table {
    width: 100%;
}
.files_table tr td{
    text-align: center;
}
.text_center {
    text-align: center;
}
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.content_row {
    display: flex;
    width: 100%;
    gap: 15px;
}
.sub_group_select {
    padding: 12px 16px;
    min-width: 150px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}
.search_input_container {
    position: relative;
    z-index: 3;
    width: 100%;
}

.search_input_container svg {
    position: absolute;
    top: 15px;
    right: 15px;
}

.search_input_block {
    position: relative;
}

.catalog_search_input {
    padding: 6px 16px;
    padding-right: 40px;
    min-width: 461px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #C8E4FF;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
}

.catalog_search_input:focus {
    outline: none;
}

.search_results {
    position: absolute;
    top: 48px;
    height: 500px;
    z-index: 1;
    overflow: auto;
    background: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #C8E4FF;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.search_results .main_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
    padding: 12px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .show_all_link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
    padding: 0px 16px;
}

.search_results .products {
    width: 100%;
}

.search_results .products {
    width: 100%;
}
.search_results .cat_title {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding: 6px 16px;
    margin: 0;
    cursor: pointer;
}

.search_results .cat_title:hover {
    background: rgba(200, 228, 255, 0.5);
}

.zindex0 {
    z-index: 0!important;
}

.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.delete_file_btn {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30);
    display: flex;
    width: 133px;
    height: 40px;
    padding: 12px 30px;
    justify-content: center;
    align-items: center;
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}
</style>
